import { Injectable } from "@angular/core";
import { Router, CanActivate } from "@angular/router";
import { AuthService } from "../services/auth.service";

@Injectable({
  providedIn: "root"
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    public auth: AuthService,
  ) { }

  canActivate(): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      if (this.auth.authenticated()) return resolve(true);
      this.router.navigate(["/"]);
      reject(false);
    });
  }
}
